import React from 'react';
import { Modal } from 'react-bootstrap';
import { InternalTransferVS } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';

export default function InternalTransferModal({ show, handleClose, onSubmit }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const initialValues = {
        personName: '',
        refNumber: '',
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: InternalTransferVS,
        onSubmit: (values) => {
            onSubmit(values);
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={'Transfer Details'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <div className={styles.flexex}>
                        <div className="w-100">
                            <CustomInput
                                label={'Person Name / Label'}
                                placeholder={'Who is transferring?'}
                                value={values.personName}
                                onChange={(e) => setFieldValue('personName', e.target.value)}
                                autoComplete="off"
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.personName && touched.personName ? errors.personName : ''}
                            />

                            <CustomInput
                                label={'Reference Number'}
                                placeholder={'e.g. REF-12345'}
                                value={values.refNumber}
                                onChange={(e) => setFieldValue('refNumber', e.target.value)}
                                CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                                CustomLabelStyle={styles.CustomLabelStyle}
                                InputContainerStyle={styles.InputContainerStyle}
                                error={errors.refNumber && touched.refNumber ? errors.refNumber : ''}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={'Submit Transfer'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
